import type { Translatable } from "app/pages/sales-intelligence/types";

export const ONBOARDING_INFO_DESCRIPTIONS_LIST: readonly Translatable[] = [
    { key: "si.onboarding.content.info.description-list.item1" },
    { key: "si.onboarding.content.info.description-list.item2" },
    { key: "si.onboarding.content.info.description-list.item3" },
];
